import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactsService } from '@app/modules/portfolio/services/contacts.service';
import { QuangularToasterService } from '@app/services/common/toaster.service';
import { ApiStatusCode } from '@common/enums/ApiStatusCode';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-user-contact-list',
  templateUrl: './user-contact-list.component.html',
  styleUrls: ['./user-contact-list.component.scss', '../user-details/user-details.component.scss'],
  providers: [ConfirmationService],
})
export class UserContactListComponent implements OnChanges {
  @Input() showModal: boolean = false;
  @Input() mnemonic: string = '';
  @Input() contacts: string[] = [];
  @Input() roleLabel: string = ''; 
  @Output() openUser = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() emitSavedChanges = new EventEmitter<any>();

  constructor(private readonly contactsService: ContactsService, 
    public readonly confirmationService: ConfirmationService,
    private readonly sanitizer: DomSanitizer,
    private readonly qToaster: QuangularToasterService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showModal) {
      this.showModal = changes.showModal.currentValue;
    }
  }
  onContactClick(contact: any) {
    this.openUser.emit(contact);
}
closeModal(){
  this.showModal = false;
}
sendEmail(): void {
    if (this.contacts.length > 0) {
      const to = this.contacts.join(';');
      const encodedSubject = encodeURIComponent("[Placeholder]");
      const encodedBody = encodeURIComponent("[Placeholder]");
      const mailtoLink = `mailto:${to}?subject=${encodedSubject}&body=${encodedBody}`;
      window.open(mailtoLink, '_blank');
    }
}
deleteContact(event: Event, contact){
  event.stopPropagation();
  this.confirmationService.confirm({
        message:
          `Do you want to go ahead and remove ${contact.displayName}'s Contact from ${contact.company ?? this.mnemonic} ?`,
        header: 'Remove Contact',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.contactsService.deleteContact({...contact, roleKey: this.roleLabel, mnemonic: this.mnemonic}).subscribe({
            next: (res) => {
              this.qToaster.showToast({
                message: res.message,
                status: res?.status
              });

              if (res?.status == ApiStatusCode.Success) {
                this.showModal = false;
                // Remove 
                const index = this.contacts.findIndex((c: any) => c.email === contact.email);
                if (index > -1) {
                  this.contacts.splice(index, 1);
                }
                this.emitSavedChanges.emit(contact);
              }
            }, error: (err) => {
              this.qToaster.showToast({
                message: err.message,
                status: "error"
              });
            }
          });
        },
        reject: () => {},
  });
}

  /**
   * Create a sanitized URL for the photo
   */
  getSafePhotoUrl(photoUrl: any): void {
    let safePhotoUrl = null;
    if (photoUrl) {
      safePhotoUrl = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,'+photoUrl);
    }

    return safePhotoUrl;
  }

}
